import React from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { LIVE_VISITORS, RECENT_VISITORS, TRK_FEED } from '../../constants';

export default function TrackingScreen() {
  const { isMobile, rp } = useBreakpoint();
  const px = rp({ mobile: '14px', tablet: '18px', desktop: '24px' });

  return (
    <div style={{ flex: 1, overflowY: 'auto' }}>
      <div style={{ padding: `16px ${px}`, maxWidth: '1100px', margin: '0 auto' }}>
        {/* Top bar */}
        <div style={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'space-between', flexDirection: isMobile ? 'column' : 'row', gap: '10px', marginBottom: '14px' }}>
          <div>
            <div style={{ fontSize: rp({ mobile: '18px', desktop: '20px' }), fontWeight: '800', color: 'var(--navy)' }}>Live Tracking</div>
            <div style={{ fontSize: '12px', color: 'var(--text3)' }}>Real-time activity across all content</div>
          </div>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '20px', background: '#F0FFF4', border: '1px solid #9AE6B4', fontSize: '12px', fontWeight: '700', color: '#276749', flexShrink: 0 }}>
            <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block' }} />
            {LIVE_VISITORS.length} viewing now
          </span>
        </div>

        {/* KPI strip — 4 cols → 2x2 */}
        <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr 1fr', desktop: 'repeat(4,1fr)' }), gap: '10px', marginBottom: '16px' }}>
          {[
            { ico: 'ti-radio',          color: '#22C55E', bg: '#F0FFF4', val: LIVE_VISITORS.length, label: 'Live now'     },
            { ico: 'ti-eye',            color: '#C8973A', bg: '#FDF4E7', val: 47,                   label: 'Views today'  },
            { ico: 'ti-clock',          color: '#1E4E8C', bg: '#EBF8FF', val: '4:32',               label: 'Avg time'     },
            { ico: 'ti-alert-triangle', color: '#C53030', bg: '#FFF5F5', val: 3,                    label: 'Drop-offs'    },
          ].map(k => (
            <div key={k.label} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '12px 14px', display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '9px', background: k.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className={`ti ${k.ico}`} style={{ color: k.color, fontSize: '16px' }} />
              </div>
              <div>
                <div style={{ fontSize: '20px', fontWeight: '800', color: 'var(--navy)', lineHeight: 1 }}>{k.val}</div>
                <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '.04em' }}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Main grid — 2 cols → stacked */}
        <div style={{ display: 'grid', gridTemplateColumns: rp({ mobile: '1fr', desktop: '1fr 1fr' }), gap: '14px' }}>
          {/* Left: visitors */}
          <div>
            {/* Live */}
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block' }} />
              Live visitors
              <span style={{ fontSize: '11px', color: 'var(--text3)', fontWeight: '400' }}>{LIVE_VISITORS.length} active</span>
            </div>
            {LIVE_VISITORS.map((v, i) => (
              <div key={i} style={{ background: 'white', border: '1.5px solid #9AE6B4', borderRadius: '12px', padding: '12px 14px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: 'var(--navy)', color: '#C8973A', fontSize: '10px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative' }}>
                    {v.ini}
                    <span style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '10px', height: '10px', borderRadius: '50%', background: '#22C55E', border: '1.5px solid white' }} />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.name}</div>
                    <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{v.org}</div>
                  </div>
                  <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#F0FFF4', color: '#276749', border: '1px solid #9AE6B4', flexShrink: 0 }}>Live</span>
                </div>
                <div style={{ fontSize: '11px', color: 'var(--text2)', marginBottom: '6px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  📄 {v.coll} — Page {v.page}/{v.totalPages}
                </div>
                <div style={{ display: 'flex', gap: '8px', fontSize: '10px', color: 'var(--text3)', flexWrap: 'wrap' }}>
                  <span>⏱ {v.timeOnPage}</span>
                  <span>Total: {v.totalTime}</span>
                  <span>📱 {v.device}</span>
                </div>
                <div style={{ display: 'flex', gap: '3px', marginTop: '8px' }}>
                  {Array.from({ length: v.totalPages }, (_, j) => (
                    <div key={j} style={{ flex: 1, height: '4px', borderRadius: '2px', background: v.pagesVisited.includes(j+1) ? (j+1 === v.page ? '#22C55E' : '#C8973A') : 'var(--border)' }} />
                  ))}
                </div>
              </div>
            ))}

            {/* Recent */}
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px', marginTop: '4px' }}>
              <i className="ti ti-clock-hour-4" style={{ fontSize: '13px', color: 'var(--text3)' }} />
              Recent (last 2 hrs)
            </div>
            {RECENT_VISITORS.map((v, i) => (
              <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '11px 14px', marginBottom: '8px', opacity: .85 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: 'var(--surface)', color: 'var(--text2)', fontSize: '10px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, border: '1.5px solid var(--border)' }}>{v.ini}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--navy)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.name} <span style={{ fontWeight: '400', color: 'var(--text3)' }}>· {v.org}</span></div>
                    <div style={{ fontSize: '10px', color: 'var(--text3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.coll} · {v.totalTime} · {v.lastSeen}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right: feed */}
          <div>
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-activity" style={{ fontSize: '13px', color: 'var(--text3)' }} />
              Live feed
            </div>
            <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
              {TRK_FEED.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '11px 14px', borderBottom: i < TRK_FEED.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: item.dot, flexShrink: 0, marginTop: '4px' }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '12px', color: 'var(--text2)', lineHeight: 1.5 }} dangerouslySetInnerHTML={{ __html: item.text }} />
                    <div style={{ fontSize: '10px', color: 'var(--text3)', marginTop: '2px' }}>{item.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
